module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ded"
    }
  })]), _c('a', {
    attrs: {
      "id": "ded"
    }
  }, [_c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("Dedication and Acknowledgments")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Over the years, I’ve had the opportunity to coach writers whose e-mail documents were a career liability. Their e-mails were either heavily revised before being sent through the chain of command, or they were bounced back for more and more rewriting. These poor writers were extremely intelligent, highly motivated people who excelled in other aspects of their jobs. Only their writing held them back.")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("After learning a few e-mail writing techniques and how to apply them, these writers went on to succeed and, in some cases, receive company-wide commendation for their written documents. In other words, workers singled out for poor communication skills became writers praised for the high quality of their e-mail.")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("I dedicate this book to them.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-411af9a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bano_9781601638632_oeb_ded_r1.vue
// module id = 66
// module chunks = 0